/** Item de navegação do shell — rótulo + caminho + ícone (puramente visual, sem lógica de negócio). */
export interface ItemNavegacao {
  rotulo: string;
  caminho: string;
  /** Chave de `ICONES_NAVEGACAO` (`erp-sidebar.ts`) — decorativo, nunca implica permissão ou dado. */
  icone: string;
}

export interface GrupoNavegacao {
  titulo?: string;
  itens: ItemNavegacao[];
}

/**
 * Mapa de navegação do ERP (`PRODUCT.md`/`ROADMAP.md`). Cada módulo
 * listado aqui existe como item de menu desde já, mesmo antes de seu
 * backend/tela existir — ao navegar para um caminho sem página real
 * registrada, o roteador (`main.ts`) mostra o estado "módulo ainda não
 * implementado" (`core/pages/modulo-indisponivel.page.ts`), nunca uma
 * tela quebrada ou dado inventado.
 */
export const GRUPOS_NAVEGACAO: GrupoNavegacao[] = [
  {
    titulo: 'Principal',
    itens: [
      { rotulo: 'Dashboard', caminho: '/dashboard', icone: 'dashboard' },
      { rotulo: 'Clientes', caminho: '/clientes', icone: 'usuarios' },
      { rotulo: 'Pedidos', caminho: '/pedidos', icone: 'carrinho' },
      { rotulo: 'Produção', caminho: '/producao', icone: 'producao' },
      { rotulo: 'Estoque', caminho: '/estoque', icone: 'estoque' },
      { rotulo: 'Envios', caminho: '/envios', icone: 'envios' },
    ],
  },
  {
    titulo: 'Financeiro',
    itens: [
      { rotulo: 'Financeiro', caminho: '/financeiro', icone: 'dinheiro' },
      { rotulo: 'Pedidos / Faturamento', caminho: '/financeiro/faturamento', icone: 'carrinho' },
      { rotulo: 'Caixa Banco', caminho: '/financeiro/caixa-banco', icone: 'dinheiro' },
      { rotulo: 'Bônus PG', caminho: '/bonus-pg', icone: 'bonus' },
      { rotulo: 'Minha Participação', caminho: '/minha-participacao', icone: 'parceiros' },
    ],
  },
  {
    titulo: 'Relacionamento',
    itens: [
      { rotulo: 'Suporte', caminho: '/suporte', icone: 'suporte' },
      { rotulo: 'Garantias', caminho: '/garantias', icone: 'garantias' },
      { rotulo: 'Marketing', caminho: '/marketing', icone: 'marketing' },
      { rotulo: 'Parcerias', caminho: '/parcerias', icone: 'parceiros' },
    ],
  },
  {
    titulo: 'Conteúdo',
    itens: [
      { rotulo: 'CMS do Site', caminho: '/cms', icone: 'cms' },
      { rotulo: 'Galeria de Mídia', caminho: '/galeria', icone: 'galeria' },
    ],
  },
  {
    titulo: 'Administração',
    itens: [
      { rotulo: 'Melhor Envio', caminho: '/integracoes/melhor-envio', icone: 'envios' },
      { rotulo: 'Automações', caminho: '/automacoes', icone: 'automacoes' },
      { rotulo: 'Equipe', caminho: '/admin/equipe', icone: 'usuarios' },
      { rotulo: 'Usuários', caminho: '/admin/usuarios', icone: 'usuario' },
      { rotulo: 'Papéis e Permissões', caminho: '/admin/permissoes', icone: 'permissoes' },
      { rotulo: 'Configurações', caminho: '/admin/configuracoes', icone: 'configuracoes' },
      { rotulo: 'Logs e Auditoria', caminho: '/admin/auditoria', icone: 'auditoria' },
    ],
  },
];
